import React from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { RichTextEditor } from '../ui/RichTextEditor';
import { RadioGroup } from '../ui/RadioGroup';
import { Card } from '../ui/Card';
interface Step1Props {
  data: {
    nameBangla: string;
    nameEnglish: string;
    category: string;
    description: string;
    status: string;
  };
  onChange: (field: string, value: string) => void;
  errors: Record<string, string>;
}
export function Step1TrainingInfo({
  data,
  onChange,
  errors
}: Step1Props) {
  const categories = [{
    value: 'basic',
    label: 'Basic Training'
  }, {
    value: 'advanced',
    label: 'Advanced Training'
  }, {
    value: 'specialized',
    label: 'Specialized Training'
  }, {
    value: 'refresher',
    label: 'Refresher Training'
  }];
  return <Card title="Training Information" data-id="element-29">
      <div className="space-y-6" data-id="element-30">
        <Input label="Training Name (Bangla)" value={data.nameBangla} onChange={e => onChange('nameBangla', e.target.value)} error={errors.nameBangla} placeholder="প্রশিক্ষণের নাম লিখুন" required data-id="element-31" />

        <Input label="Training Name (English)" value={data.nameEnglish} onChange={e => onChange('nameEnglish', e.target.value)} error={errors.nameEnglish} placeholder="Enter training name" required data-id="element-32" />

        <Select label="Category" value={data.category} onChange={e => onChange('category', e.target.value)} options={categories} error={errors.category} required data-id="element-33" />

        <RichTextEditor label="Description" value={data.description} onChange={value => onChange('description', value)} error={errors.description} data-id="element-34" />

        <RadioGroup label="Status" name="status" value={data.status} onChange={value => onChange('status', value)} options={[{
        value: 'active',
        label: 'Active'
      }, {
        value: 'inactive',
        label: 'Inactive'
      }]} data-id="element-35" />
      </div>
    </Card>;
}